var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[(_vm.getGameConsole === 'american')?_c('RightAmerican'):_vm._e(),(_vm.getGameConsole === 'terminal')?_c('RightTerminal'):_c('RightClassic')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }